import { observer } from 'mobx-react-lite'
import { LINK_HELP_UK_COMPLIANCE } from 'shared/constants/links'
import { Icon, Box, Typography } from 'shared/ui'
import { type UKComplianceModalStore } from '../store/UKComplianceModalStore'

import styles from './styles.module.scss'

export type UKComplianceModalContentProps = {
  store: UKComplianceModalStore
}

export const UKComplianceModalContent = observer(({ store }: UKComplianceModalContentProps) => {
  const { isAdminOrOwner } = store

  const steps = ['Complete UK compliance', 'Buy a UK number', 'Start texting and calling']

  return (
    <div>
      <Box display={'flex'} justifyContent={'center'}>
        <Icon icon={'infoCircle'} color={'var(--light-blue-60)'} fontSize={32} />
      </Box>
      <Box display={'flex'} justifyContent={'center'}>
        <Typography
          variant={'heading-lg'}
          ariaLabel={'ukComplianceModalTitle'}
          color={'var(--content-primary-primary)'}
          marginTop={'16px'}
          marginBottom={'8px'}
        >
          Get approved to use UK numbers
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'}>
        <Typography
          width={'100%'}
          className={styles.description}
          variant={'body-rg-regular'}
          ariaLabel={'ukComplianceModalDescription'}
          color={'var(--content-primary-secondary)'}
          marginBottom={'32px'}
        >
          To start texting or calling from a UK number, carriers require
          <br />
          to complete a quick compliance review.
          {!isAdminOrOwner && (
            <>
              {' '}
              Ask one of your
              <br />
              admins to complete this process.
            </>
          )}{' '}
          <Typography
            tag={'a'}
            variant={'body-md-regular'}
            color={'var(--content-brand-primary)'}
            ariaLabel={'ukComplianceModalLink'}
            className={styles.link}
            onClick={() => {
              window.open(LINK_HELP_UK_COMPLIANCE, '_blank', 'noreferrer')
            }}
          >
            Learn more
          </Typography>
        </Typography>
      </Box>
      <Box display={'flex'} flexDirection={'column'} gap={'4px'}>
        {steps.map((step, idx) => (
          <div key={step} className={styles.step}>
            <div className={styles.step__number}>
              <Typography
                variant={'body-md-regular'}
                ariaLabel={'ukComplianceModalCase1'}
                color={'var(--content-primary-primary)'}
              >
                {idx + 1}
              </Typography>
            </div>
            <Typography
              variant={'body-md-regular'}
              ariaLabel={'ukComplianceModalCase1'}
              color={'var(--content-primary-primary)'}
            >
              {step}
            </Typography>
          </div>
        ))}
      </Box>
    </div>
  )
})
